module.exports = __webpack_public_path__ + "static/media/logo.581d7613.svg";